import styled from 'styled-components'

import TextInput from '../basic-components/TextInput'

const Label = styled.label`
  flex: none;
  display: inline-block;
  text-align: right;
  padding: 0.7rem;
`
const RowContainer = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-evenly;
`

export default function ByTaxNumberDialog({parcelId, onParcelIdChange}) {

  const changeHandler = (e) => {
    onParcelIdChange(e.target.value);
  }

  return (
    <RowContainer>
     <Label>Parcel Id:</Label>
     <TextInput
        value={parcelId}
        onChange={changeHandler}
        placeholder={""}
        autoFocus={true}
      />
    </RowContainer>
  );
}
